import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AddOrder from "./AddOrder";
import Order from "./Order";
import OrderDetail from "./OrderDetail";
import NotAuthorized from "./NotAuthorized";
import NormalLayOut from "./components/NormalLayOut"
import NotAuthorizedLayout from "./components/NotAuthorizedLayout"
import Cookies from "js-cookie";

// Authentication check function
const isAuthenticated = () => {
  return Cookies.get("agpunchout-authorization") ? true : false;
};

// Protected Route Component
const ProtectedRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/not-authorized" />;
};

function App() {
  return (



    <Router>
    <Routes>
      <Route path="/" element={<ProtectedRoute element={<NormalLayOut><AddOrder /></NormalLayOut>} />} />
      <Route path="/add-order" element={<ProtectedRoute element={<NormalLayOut><AddOrder /></NormalLayOut>} />} />
      {/* <Route path="/add-product" element={<ProtectedRoute element={<NormalLayOut><AddProduct /></NormalLayOut>} />} /> */}
      {/* <Route path="/all-orders" element={<ProtectedRoute element={<NormalLayOut><Order /></NormalLayOut>} />} /> */}
      {/* <Route path="/order-detail" element={<ProtectedRoute element={<NormalLayOut><OrderDetail /></NormalLayOut>} />} /> */}
      <Route path="/not-authorized" element={<NotAuthorizedLayout><NotAuthorized /></NotAuthorizedLayout>} />
    </Routes>
  </Router> 

  );
}

export default App;